import { createClient } from "next-sanity";
import imageUrlBuilder from "@sanity/image-url";

export const sanityClient = createClient({
  projectId: "muo5rc80", // your actual Sanity project ID
  dataset: "production",
  apiVersion: "2024-05-09", // use today's date
  useCdn: true, // set to false if you want fresh data every time
});

const builder = imageUrlBuilder(sanityClient);

export function urlFor(source) {
  return builder.image(source);
}
